import { getAPIManagerInstance } from './apiManager';
import { DECKARD_API_URL, httpMethodFunctions } from './common';

export const lookupAddress = async (searchTerm, selected = undefined) => {
  const SMARTY_STREETS_API_KEY = '53172441788738393';
  const SMARTY_STREETS_LICENSE_STRING = 'us-autocomplete-pro-cloud';
  const SMARTY_STREETS_BASE_URL = `https://us-autocomplete-pro.api.smartystreets.com/lookup`;
  const searchParams = {
    key: SMARTY_STREETS_API_KEY,
    license: SMARTY_STREETS_LICENSE_STRING,
    selected: selected || '',
    search: searchTerm,
    source: 'all',
  };
  return await httpMethodFunctions.get(SMARTY_STREETS_BASE_URL, {
    params: searchParams,
  });
};

export const lookupAPNAddress = async (apn, unitNumber = '') => {
  if (!apn) return;
  try {
    let url = `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/apn/${apn}`;

    // Add unitNumber to query string if valid
    if (!!unitNumber) {
      url += `?unitNumber=${encodeURIComponent(unitNumber)}`;
    }
    let resp = await httpMethodFunctions.get(url);
    let { data } = resp;
    return data;
  } catch (err) {
    let { data } = err.response;
    return data;
  }
};

export const lookupAddressAPN = (address) => {
  if (!address) return;
  try {
    let result = httpMethodFunctions.get(
      `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/lookupAddress/${encodeURIComponent(address)}`
    );
    return result;
  } catch (err) {
    // Log err
  }
};
